import React, { FC, ReactNode, useState } from 'react';
import classNames from 'classnames';
import LazyImg from 'src/common/components/LazyImg';
import BoatPlaceholderImage from 'src/common/components/BoatPlaceholderImage';
import getClassName from 'src/common/utils/getClassName';
import s from './SimpleBoatListingItem.module.scss';

type SimpleBoatListingItem = {
  photoUrl: string;
  headline: string;
  onClick?: () => void;
  children?: ReactNode;
  variant?: 'wrapContentOnMobile';
};
const SimpleBoatListingItem: FC<SimpleBoatListingItem> = ({
  photoUrl,
  headline,
  onClick,
  children,
  variant,
}) => {
  const [imageLoadFailed, setImageLoadFailed] = useState(false);
  const image = (!!photoUrl && !imageLoadFailed) ? (
    <LazyImg
      src={photoUrl}
      alt={headline}
      height={57}
      width={88}
      className={s.image}
      onError={() => setImageLoadFailed(true)}
      imgixProps={{ auto: ['enhance'] }}
    />
  ) : (
    <BoatPlaceholderImage classNameModifier="syncCalendar" />
  );

  return (
    <div className={s.root}>
      {onClick && (
        <button
          type="button"
          onClick={onClick}
          className={s.button}
          aria-label={`Select ${headline}`}
        />
      )}
      <div className={s.imageContainer}>
        {image}
      </div>
      <div className={getClassName(s, 'content', classNames(variant))}>
        <div className={s.title}>{headline}</div>
        <div className={s.actions}>{children}</div>
      </div>
    </div>
  );
};

export default SimpleBoatListingItem;
